// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as CartProduct from "../Cart/CartProduct.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as CatalogProduct from "../Catalog/CatalogProduct.res.js";
import * as SupplierSelect from "../Supplier/SupplierSelect.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProducerSelect from "../Catalog/CatalogProducerSelect.res.js";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";
import * as ProductStockTableCell from "../Product/ProductStockTableCell.res.js";
import * as CatalogStockRangeSelect from "../Catalog/CatalogStockRangeSelect.res.js";
import * as ProductReferenceTableCell from "../Product/ProductReferenceTableCell.res.js";
import * as CatalogCategorySelectFilter from "../Catalog/CatalogCategorySelectFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query VariantsQuery($search: String, $after: String, $first: Int, $filterBy: InputVariantsQueryFilter)  {\nvariants(search: $search, after: $after, first: $first, filterBy: $filterBy)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncreatedAt  \nformattedName  \nname  \nproduct  {\n__typename  \nid  \nname  \nkind  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \nsupplier  {\n__typename  \ncompanyName  \n}\n\nformattedCategory  \nalcoholVolume  \npurchasedPrice  \nformattedPurchasedPrice  \npackaging  \nbulk  \ncapacityPrecision  \ncapacityUnit  \nstock  {\n__typename  \nrawQuantity  \nformattedQuantity  \nstate  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variants;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    variants: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.product;
        let value$3 = value$2.kind;
        let tmp;
        switch (value$3) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$2.color;
        let tmp$1;
        if (value$4 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$4) {
            case "AMBER" :
              tmp$2 = "AMBER";
              break;
            case "BLACK" :
              tmp$2 = "BLACK";
              break;
            case "BLOND" :
              tmp$2 = "BLOND";
              break;
            case "DARK" :
              tmp$2 = "DARK";
              break;
            case "ORANGE" :
              tmp$2 = "ORANGE";
              break;
            case "RED" :
              tmp$2 = "RED";
              break;
            case "ROSE" :
              tmp$2 = "ROSE";
              break;
            case "WHITE" :
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$5 = value$2.wineType;
        let tmp$3;
        if (value$5 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$5) {
            case "EFFERVESCENT" :
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL" :
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$6 = value$2.whiteWineType;
        let tmp$5;
        if (value$6 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$6) {
            case "DRY" :
              tmp$6 = "DRY";
              break;
            case "SEMIDRY" :
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT" :
              tmp$6 = "SOFT";
              break;
            case "SWEET" :
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$7 = value$2.beerType;
        let value$8 = value$2.producer;
        let value$9 = value$2.designation;
        let value$10 = value$2.family;
        let value$11 = value$2.region;
        let value$12 = value$2.country;
        let value$13 = value$2.tax;
        let value$14 = value$1.stockKeepingUnit;
        let value$15 = value$1.priceLookUpCode;
        let value$16 = value$1.internalCode;
        let value$17 = value$1.supplier;
        let value$18 = value$1.formattedCategory;
        let value$19 = value$1.alcoholVolume;
        let value$20 = value$1.purchasedPrice;
        let value$21 = value$1.formattedPurchasedPrice;
        let value$22 = value$1.packaging;
        let value$23 = value$1.bulk;
        let value$24 = value$1.capacityPrecision;
        let value$25 = value$1.capacityUnit;
        let value$26 = value$1.stock;
        let value$27 = value$26.rawQuantity;
        let value$28 = value$26.formattedQuantity;
        let value$29 = value$26.state;
        let tmp$7;
        if (value$29 == null) {
          tmp$7 = undefined;
        } else {
          let tmp$8;
          switch (value$29) {
            case "ALERT" :
              tmp$8 = "ALERT";
              break;
            case "DANGER" :
              tmp$8 = "DANGER";
              break;
            case "OK" :
              tmp$8 = "OK";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$7 = tmp$8;
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            formattedName: value$1.formattedName,
            name: value$1.name,
            product: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              kind: tmp,
              color: tmp$1,
              wineType: tmp$3,
              whiteWineType: tmp$5,
              beerType: !(value$7 == null) ? value$7 : undefined,
              producer: !(value$8 == null) ? value$8 : undefined,
              designation: !(value$9 == null) ? value$9 : undefined,
              family: !(value$10 == null) ? value$10 : undefined,
              region: !(value$11 == null) ? value$11 : undefined,
              country: !(value$12 == null) ? value$12 : undefined,
              tax: {
                __typename: value$13.__typename,
                value: value$13.value
              }
            },
            stockKeepingUnit: !(value$14 == null) ? value$14 : undefined,
            priceLookUpCode: !(value$15 == null) ? value$15 : undefined,
            internalCode: !(value$16 == null) ? value$16 : undefined,
            supplier: !(value$17 == null) ? ({
                __typename: value$17.__typename,
                companyName: value$17.companyName
              }) : undefined,
            formattedCategory: !(value$18 == null) ? value$18 : undefined,
            alcoholVolume: !(value$19 == null) ? value$19 : undefined,
            purchasedPrice: !(value$20 == null) ? value$20 : undefined,
            formattedPurchasedPrice: !(value$21 == null) ? value$21 : undefined,
            packaging: !(value$22 == null) ? value$22 : undefined,
            bulk: !(value$23 == null) ? value$23 : undefined,
            capacityPrecision: !(value$24 == null) ? value$24 : undefined,
            capacityUnit: !(value$25 == null) ? value$25 : undefined,
            stock: {
              __typename: value$26.__typename,
              rawQuantity: !(value$27 == null) ? value$27 : undefined,
              formattedQuantity: !(value$28 == null) ? value$28 : undefined,
              state: tmp$7
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.stock;
    let value$3 = value$2.state;
    let state = value$3 !== undefined ? (
        value$3 === "OK" ? "OK" : (
            value$3 === "ALERT" ? "ALERT" : "DANGER"
          )
      ) : null;
    let value$4 = value$2.formattedQuantity;
    let formattedQuantity = value$4 !== undefined ? value$4 : null;
    let value$5 = value$2.rawQuantity;
    let rawQuantity = value$5 !== undefined ? value$5 : null;
    let value$6 = value$2.__typename;
    let stock = {
      __typename: value$6,
      rawQuantity: rawQuantity,
      formattedQuantity: formattedQuantity,
      state: state
    };
    let value$7 = value$1.capacityUnit;
    let capacityUnit = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.capacityPrecision;
    let capacityPrecision = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.bulk;
    let bulk = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.packaging;
    let packaging = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.formattedPurchasedPrice;
    let formattedPurchasedPrice = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.purchasedPrice;
    let purchasedPrice = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.alcoholVolume;
    let alcoholVolume = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.formattedCategory;
    let formattedCategory = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.supplier;
    let supplier;
    if (value$15 !== undefined) {
      let value$16 = value$15.companyName;
      let value$17 = value$15.__typename;
      supplier = {
        __typename: value$17,
        companyName: value$16
      };
    } else {
      supplier = null;
    }
    let value$18 = value$1.internalCode;
    let internalCode = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.priceLookUpCode;
    let priceLookUpCode = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$20 !== undefined ? value$20 : null;
    let value$21 = value$1.product;
    let value$22 = value$21.tax;
    let value$23 = value$22.value;
    let value$24 = value$22.__typename;
    let tax = {
      __typename: value$24,
      value: value$23
    };
    let value$25 = value$21.country;
    let country = value$25 !== undefined ? value$25 : null;
    let value$26 = value$21.region;
    let region = value$26 !== undefined ? value$26 : null;
    let value$27 = value$21.family;
    let family = value$27 !== undefined ? value$27 : null;
    let value$28 = value$21.designation;
    let designation = value$28 !== undefined ? value$28 : null;
    let value$29 = value$21.producer;
    let producer = value$29 !== undefined ? value$29 : null;
    let value$30 = value$21.beerType;
    let beerType = value$30 !== undefined ? value$30 : null;
    let value$31 = value$21.whiteWineType;
    let whiteWineType = value$31 !== undefined ? (
        value$31 === "SWEET" ? "SWEET" : (
            value$31 === "SEMIDRY" ? "SEMIDRY" : (
                value$31 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : null;
    let value$32 = value$21.wineType;
    let wineType = value$32 !== undefined ? (
        value$32 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : null;
    let value$33 = value$21.color;
    let color = value$33 !== undefined ? (
        value$33 === "ORANGE" ? "ORANGE" : (
            value$33 === "RED" ? "RED" : (
                value$33 === "AMBER" ? "AMBER" : (
                    value$33 === "DARK" ? "DARK" : (
                        value$33 === "BLACK" ? "BLACK" : (
                            value$33 === "BLOND" ? "BLOND" : (
                                value$33 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$34 = value$21.kind;
    let kind = value$34 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$34 === "BEER" ? "BEER" : (
            value$34 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$35 = value$21.name;
    let value$36 = value$21.id;
    let value$37 = value$21.__typename;
    let product = {
      __typename: value$37,
      id: value$36,
      name: value$35,
      kind: kind,
      color: color,
      wineType: wineType,
      whiteWineType: whiteWineType,
      beerType: beerType,
      producer: producer,
      designation: designation,
      family: family,
      region: region,
      country: country,
      tax: tax
    };
    let value$38 = value$1.name;
    let value$39 = value$1.formattedName;
    let value$40 = value$1.createdAt;
    let value$41 = Scalar.Datetime.serialize(value$40);
    let value$42 = value$1.id;
    let value$43 = value$1.__typename;
    let node = {
      __typename: value$43,
      id: value$42,
      createdAt: value$41,
      formattedName: value$39,
      name: value$38,
      product: product,
      stockKeepingUnit: stockKeepingUnit,
      priceLookUpCode: priceLookUpCode,
      internalCode: internalCode,
      supplier: supplier,
      formattedCategory: formattedCategory,
      alcoholVolume: alcoholVolume,
      purchasedPrice: purchasedPrice,
      formattedPurchasedPrice: formattedPurchasedPrice,
      packaging: packaging,
      bulk: bulk,
      capacityPrecision: capacityPrecision,
      capacityUnit: capacityUnit,
      stock: stock
    };
    let value$44 = value.__typename;
    return {
      __typename: value$44,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let variants = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    variants: variants
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectNullableStringEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a !== undefined ? a : undefined
  };
}

function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectInputVariantsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.stockKeepingUnit;
  let a$2 = inp.ean13;
  let a$3 = inp.active;
  let a$4 = inp.archived;
  let a$5 = inp.createdAt;
  let a$6 = inp.updatedAt;
  let a$7 = inp.categoryId;
  let a$8 = inp.supplierId;
  let a$9 = inp.stock;
  let a$10 = inp.producer;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    stockKeepingUnit: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    ean13: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    active: a$3 !== undefined ? ({
        _equals: a$3._equals
      }) : undefined,
    archived: a$4 !== undefined ? (
        a$4 === "ONLY" ? "ONLY" : (
            a$4 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    createdAt: a$5 !== undefined ? serializeInputObjectDateFilter(a$5) : undefined,
    updatedAt: a$6 !== undefined ? serializeInputObjectDateFilter(a$6) : undefined,
    categoryId: a$7 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$7) : undefined,
    supplierId: a$8 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$8) : undefined,
    stock: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined,
    producer: a$10 !== undefined ? ({
        _equals: a$10._equals
      }) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.after;
  let a$2 = inp.first;
  let a$3 = inp.filterBy;
  return {
    search: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined,
    first: a$2 !== undefined ? a$2 : undefined,
    filterBy: a$3 !== undefined ? serializeInputObjectInputVariantsQueryFilter(a$3) : undefined
  };
}

function makeVariables(search, after, first, filterBy) {
  return {
    search: search,
    after: after,
    first: first,
    filterBy: filterBy
  };
}

function makeInputObjectInputVariantsQueryFilter(shopIds, stockKeepingUnit, ean13, active, archived, createdAt, updatedAt, categoryId, supplierId, stock, producer, param) {
  return {
    shopIds: shopIds,
    stockKeepingUnit: stockKeepingUnit,
    ean13: ean13,
    active: active,
    archived: archived,
    createdAt: createdAt,
    updatedAt: updatedAt,
    categoryId: categoryId,
    supplierId: supplierId,
    stock: stock,
    producer: producer
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectNullableStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    after: undefined,
    first: undefined,
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function rowsFromEdgesData(data) {
  return data.map(edge => {
    let match = edge.node;
    let match$1 = match.bulk;
    let tmp;
    if (match$1 !== undefined && match$1) {
      let precision = match.capacityPrecision;
      tmp = precision !== undefined ? precision : undefined;
    } else {
      tmp = undefined;
    }
    return {
      id: edge.node.id,
      formattedName: edge.node.formattedName,
      createdAt: edge.node.createdAt,
      productKind: edge.node.product.kind,
      purchasedPrice: Stdlib_Option.getOr(edge.node.purchasedPrice, 0),
      formattedPurchasedPrice: edge.node.formattedPurchasedPrice,
      packaging: edge.node.packaging,
      bulkPrecision: tmp,
      capacityUnit: edge.node.capacityUnit,
      tax: edge.node.product.tax.value,
      stockQuantity: edge.node.stock.rawQuantity,
      stockFormattedQuantity: edge.node.stock.formattedQuantity,
      stockState: edge.node.stock.state,
      information: {
        productName: edge.node.product.name,
        variantName: edge.node.name,
        sku: edge.node.stockKeepingUnit,
        plu: Stdlib_Option.map(edge.node.priceLookUpCode, plu => plu.toString()),
        internalCode: edge.node.internalCode,
        color: edge.node.product.color,
        producerName: edge.node.product.producer,
        designation: edge.node.product.designation,
        productFamily: edge.node.product.family,
        wineType: edge.node.product.wineType,
        whiteWineType: edge.node.product.whiteWineType,
        beerType: edge.node.product.beerType,
        region: edge.node.product.region,
        country: Stdlib_Option.getOr(edge.node.product.country, "—"),
        categoryName: Stdlib_Option.getOr(edge.node.formattedCategory, "—"),
        supplierName: Stdlib_Option.map(edge.node.supplier, supplier => supplier.companyName),
        alcoholVolume: Stdlib_Option.map(edge.node.alcoholVolume, alcoholVolume => I18n.decimalFormat(undefined, undefined, 1, undefined, alcoholVolume) + "°")
      }
    };
  });
}

let columns = [
  {
    key: "reference",
    name: I18n.t("Product"),
    layout: {
      width: {
        NAME: "pct",
        VAL: 65
      },
      margin: "large"
    },
    render: param => {
      let product = param.data;
      let badgeNew = DateHelpers.diffInHours(new Date(), product.createdAt) <= 24 ? ({
          variation: "information",
          text: I18n.t("New")
        }) : undefined;
      return JsxRuntime.jsx(ProductReferenceTableCell.make, {
        badge: badgeNew,
        disabled: param.disabled,
        productKind: product.productKind,
        information: product.information
      });
    }
  },
  {
    key: "stock",
    name: I18n.t("Stock"),
    render: param => {
      let product = param.data;
      if (param.disabled) {
        return JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Already added"),
          variation: "subdued",
          size: "small"
        });
      } else {
        return JsxRuntime.jsx(ProductStockTableCell.make, {
          value: product.stockFormattedQuantity,
          state: product.stockState,
          size: "xsmall"
        });
      }
    }
  },
  {
    key: "purchasedPrice",
    name: I18n.t("Purchase price"),
    layout: {
      width: {
        NAME: "px",
        VAL: 140
      }
    },
    render: param => {
      if (param.disabled) {
        return null;
      } else {
        return JsxRuntime.jsx(ProductPriceTableCell.make, {
          value: param.data.formattedPurchasedPrice,
          size: "xsmall"
        });
      }
    }
  }
];

function setDefaultOrderedQuantityValue(productInput) {
  if (productInput.TAG === "Unit") {
    let product = productInput.product;
    return {
      TAG: "Unit",
      product: {
        id: product.id,
        identifier: product.identifier,
        stockKeepingUnit: product.stockKeepingUnit,
        name: product.name,
        description: product.description,
        capacityUnit: product.capacityUnit,
        stock: product.stock,
        packaging: product.packaging,
        quantity: 1,
        expectedQuantity: product.expectedQuantity,
        unitPrice: product.unitPrice,
        fees: product.fees,
        discounts: product.discounts,
        tax: product.tax
      }
    };
  }
  let product$1 = productInput.product;
  return {
    TAG: "Bulk",
    product: {
      id: product$1.id,
      identifier: product$1.identifier,
      stockKeepingUnit: product$1.stockKeepingUnit,
      name: product$1.name,
      description: product$1.description,
      capacityUnit: product$1.capacityUnit,
      stock: product$1.stock,
      packaging: product$1.packaging,
      quantity: 1,
      expectedQuantity: product$1.expectedQuantity,
      unitPrice: product$1.unitPrice,
      fees: product$1.fees,
      discounts: product$1.discounts,
      tax: product$1.tax
    },
    precision: productInput.precision
  };
}

let make = React.memo(props => {
  let onCommit = props.onCommit;
  let selectedProducts = props.selectedProducts;
  let renderStartText = () => {
    let length = selectedProducts.length;
    let shouldBePrimaryView = length > 0;
    let formattedText = length.toString() + ` ` + I18n.t(I18n.isPlural(length) ? "selected products" : "selected product");
    return JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: formattedText,
        variation: shouldBePrimaryView ? "primary" : "neutral",
        weight: shouldBePrimaryView ? "strong" : "regular"
      })
    });
  };
  let onCommit$1 = () => onCommit(selectedProducts.map(row => setDefaultOrderedQuantityValue(CartProduct.makeProductInput(row.id, row.formattedName, CatalogProduct.Information.formatDescription(row.productKind, row.information, undefined, undefined, undefined, undefined), row.information.sku, row.stockQuantity, row.packaging, row.tax, row.purchasedPrice, undefined, row.bulkPrecision, row.capacityUnit, undefined))));
  return JsxRuntime.jsx(Modal.make, {
    children: props.children,
    opened: props.opened,
    title: I18n.t("Product append"),
    variation: "secondary",
    compact: false,
    backgroundColor: "#fefefe",
    renderStartText: renderStartText,
    abortButtonText: I18n.t("Cancel"),
    allowCommit: selectedProducts.length !== 0,
    commitButtonTone: "brand",
    commitButtonText: I18n.t("Add products"),
    commitButtonCallback: onCommit$1,
    onRequestClose: props.onRequestClose
  });
});

let PickerModal = {
  make: make
};

function makeVariables$1(search, filters, after, param) {
  let shopId = filters.shopId;
  let category = filters.category;
  let tmp;
  if (category !== undefined) {
    let categoryId = category.id;
    tmp = {
      _equals: (categoryId == null) ? null : categoryId
    };
  } else {
    tmp = undefined;
  }
  let supplier = filters.supplier;
  let tmp$1;
  if (supplier !== undefined) {
    let supplierId = supplier.id;
    tmp$1 = {
      _equals: (supplierId == null) ? null : supplierId
    };
  } else {
    tmp$1 = undefined;
  }
  let match = filters.stock;
  let producer = filters.producer;
  return makeVariables(search, after, 20, makeInputObjectInputVariantsQueryFilter(shopId !== undefined ? ({
      _in: [shopId]
    }) : undefined, undefined, undefined, undefined, undefined, undefined, undefined, tmp, tmp$1, match !== undefined ? ({
      _min: match.min,
      _max: match.max,
      _between: undefined
    }) : undefined, producer !== undefined ? ({
      _equals: producer
    }) : undefined, undefined));
}

function runScanEdges(fetcher, cursor, dataOpt, param) {
  let data = dataOpt !== undefined ? dataOpt : [];
  return Future.flatMapOk(Future.mapError(FuturePromise.fromPromise(fetcher(cursor)), undefined, param => {}), undefined, response => {
    if (response.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match = response._0;
    let match$1 = match.data.variants;
    let match$2 = match$1.pageInfo;
    let match$3 = match$2.hasNextPage;
    if (match$3 !== undefined && match$3) {
      if (match.error !== undefined) {
        return Future.value({
          TAG: "Error",
          _0: undefined
        });
      } else {
        return runScanEdges(fetcher, match$2.endCursor, Belt_Array.concatMany([
          data,
          match$1.edges
        ]), undefined);
      }
    }
    if (match.error !== undefined) {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    } else {
      return Future.value({
        TAG: "Ok",
        _0: Belt_Array.concatMany([
          data,
          match$1.edges
        ])
      });
    }
  });
}

function initialState(filters) {
  return {
    searchQuery: "",
    filters: filters,
    selectedProducts: []
  };
}

function make$1(state, action) {
  switch (action.TAG) {
    case "Searched" :
      return {
        searchQuery: action._0,
        filters: state.filters,
        selectedProducts: state.selectedProducts
      };
    case "FiltersUpdated" :
      return {
        searchQuery: state.searchQuery,
        filters: action._0(state.filters),
        selectedProducts: state.selectedProducts
      };
    case "ProductSelectionUpdated" :
      let allProducts = action._1;
      let tableSelection = action._0;
      let prev = state.selectedProducts;
      let selectedProducts;
      selectedProducts = typeof tableSelection !== "object" ? prev : Stdlib_Array.filterMap(tableSelection._0, selectedRowId => Belt_Array.concatMany([
          allProducts,
          prev
        ]).find(row => row.id === selectedRowId));
      return {
        searchQuery: state.searchQuery,
        filters: state.filters,
        selectedProducts: selectedProducts
      };
    case "ResetSearchAndFilters" :
      let initialState = action._0;
      return {
        searchQuery: initialState.searchQuery,
        filters: initialState.filters,
        selectedProducts: state.selectedProducts
      };
  }
}

let Reducer = {
  initialState: initialState,
  make: make$1
};

function OrderProductFormPickerModalTable(props) {
  let __disabledIds = props.disabledIds;
  let __supplierName = props.supplierName;
  let supplierId = props.supplierId;
  let shopId = props.shopId;
  let opened = props.opened;
  let supplierName = __supplierName !== undefined ? __supplierName : "?";
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let initialState_filters = {
    shopId: shopId
  };
  let initialState_selectedProducts = [];
  let initialState = {
    searchQuery: "",
    filters: initialState_filters,
    selectedProducts: initialState_selectedProducts
  };
  let match = React.useReducer(make$1, initialState);
  let dispatch = match[1];
  let state = match[0];
  let query = use(undefined, undefined, undefined, undefined, "NetworkOnly", "CacheFirst", undefined, true, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shopId), undefined, makeVariables$1(state.searchQuery, state.filters, undefined, undefined));
  let asyncResult = ApolloHelpers.useQueryResultToAsyncResultWithVariablesReloading2(query, state.searchQuery, state.filters);
  let data = AsyncResult.mapOk(asyncResult, data => rowsFromEdgesData(data.variants.edges));
  React.useEffect(() => {
    if (!opened && state.searchQuery !== "") {
      dispatch({
        TAG: "Searched",
        _0: ""
      });
    }
  }, [opened]);
  ReactUpdateEffect.use1(() => {
    dispatch({
      TAG: "FiltersUpdated",
      _0: prev => {
        let newrecord = {...prev};
        newrecord.shopId = shopId;
        return newrecord;
      }
    });
  }, [shopId]);
  React.useEffect(() => {
    let supplier = Stdlib_Option.flatMap(supplierId, id => {
      if (id !== "") {
        return {
          id: id,
          name: supplierName
        };
      }
    });
    dispatch({
      TAG: "FiltersUpdated",
      _0: prev => {
        let newrecord = {...prev};
        newrecord.supplier = supplier;
        return newrecord;
      }
    });
  }, [supplierId]);
  let onLoadMore = React.useCallback(() => {
    if (typeof asyncResult !== "object") {
      return;
    }
    if (asyncResult.TAG !== "Done") {
      return;
    }
    let data = asyncResult._0;
    if (data.TAG !== "Ok") {
      return;
    }
    let data$1 = data._0;
    if (data$1.variants.pageInfo.hasNextPage === true) {
      query.fetchMore(undefined, undefined, makeVariables$1(state.searchQuery, state.filters, data$1.variants.pageInfo.endCursor, undefined), (prevResult, param) => {
        let fetchMoreResult = param.fetchMoreResult;
        if (fetchMoreResult === undefined) {
          return prevResult;
        }
        let newVariants = fetchMoreResult.variants;
        return {
          variants: {
            __typename: newVariants.__typename,
            pageInfo: newVariants.pageInfo,
            edges: Belt_Array.concatMany([
              prevResult.variants.edges,
              newVariants.edges
            ])
          }
        };
      }, undefined);
      return;
    }
  }, [asyncResult]);
  let onSelectChange = React.useCallback(selection => {
    let rowsData;
    if (typeof data !== "object") {
      rowsData = data === "NotAsked" ? [] : [];
    } else if (data.TAG === "Reloading") {
      let data$1 = data._0;
      rowsData = data$1.TAG === "Ok" ? data$1._0 : [];
    } else {
      let data$2 = data._0;
      rowsData = data$2.TAG === "Ok" ? data$2._0 : [];
    }
    dispatch({
      TAG: "ProductSelectionUpdated",
      _0: selection,
      _1: rowsData
    });
  }, [
    data,
    disabledIds
  ]);
  let filters = [
    JsxRuntime.jsx(SupplierSelect.make, {
      size: "compact",
      label: I18n.t("Supplier"),
      preset: "filter",
      showDefaultItems: true,
      hideOverlayFooter: true,
      shopId: shopId,
      value: state.filters.supplier,
      onChange: supplier => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.supplier = supplier;
          return newrecord;
        }
      })
    }),
    JsxRuntime.jsx(CatalogCategorySelectFilter.make, {
      shopId: shopId,
      value: state.filters.category,
      onChange: category => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.category = category;
          return newrecord;
        }
      })
    }),
    JsxRuntime.jsx(CatalogProducerSelect.make, {
      shopId: shopId,
      value: state.filters.producer,
      onChange: producer => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.producer = producer;
          return newrecord;
        }
      })
    }),
    JsxRuntime.jsx(CatalogStockRangeSelect.make, {
      disabled: Stdlib_Option.isNone(shopId),
      value: state.filters.stock,
      onChange: stock => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => {
          let newrecord = {...prev};
          newrecord.stock = stock;
          return newrecord;
        }
      })
    })
  ];
  let placeholderEmptyState = Stdlib_Option.isNone(shopId) ? JsxRuntime.jsx(Placeholder.make, {
      status: {
        TAG: "Pending",
        title: I18n.t("Beware !"),
        message: I18n.t("Select the shop in charge of the order to start adding products."),
        illustration: undefined
      },
      childComponent: () => JsxRuntime.jsx(OrderEditForm.InputSelect.make, {
        field: "ShopId",
        label: I18n.t("Shop"),
        placeholder: I18n.t("Select a shop"),
        sections: [{
            items: Auth.useShops().map(shop => ({
              TAG: "Option",
              key: shop.id,
              label: shop.name,
              value: shop.id
            }))
          }]
      })
    }) : JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "ResetSearchAndFilters",
          _0: initialState
        })
      })
    });
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(AnimatedRender.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(TableView.make, {
          data: data,
          columns: columns,
          keyExtractor: row => row.id,
          disabledRowsKeys: disabledIds,
          selectionEnabled: true,
          selectAllEnabled: false,
          hideReloadingPlaceholder: true,
          compactRows: true,
          placeholderEmptyState: placeholderEmptyState,
          searchQuery: state.searchQuery,
          searchPlaceholder: I18n.t("Search product"),
          filters: filters,
          onSearchQueryChange: value => dispatch({
            TAG: "Searched",
            _0: value
          }),
          onLoadMore: onLoadMore,
          onSelectChange: onSelectChange
        }),
        style: {
          display: "flex",
          maxHeight: "70vh",
          minHeight: "70vh"
        }
      }),
      displayed: opened,
      animation: "fadePopinTranslation",
      duration: 300
    }),
    opened: opened,
    selectedProducts: state.selectedProducts,
    onCommit: props.onCommit,
    onRequestClose: props.onRequestClose
  });
}

let make$2 = React.memo(OrderProductFormPickerModalTable, (oldProps, newProps) => {
  if (oldProps.opened === newProps.opened && oldProps.shopId === newProps.shopId) {
    return oldProps.supplierId === newProps.supplierId;
  } else {
    return false;
  }
});

export {
  Query,
  rowsFromEdgesData,
  columns,
  setDefaultOrderedQuantityValue,
  PickerModal,
  makeVariables$1 as makeVariables,
  runScanEdges,
  Reducer,
  make$2 as make,
}
/* query Not a pure module */
